import { text } from '\@boba-cli/dsl';
export const makeDemoHeader = (title) => text(`🧋 Boba Demo - ${title}`).bold().foreground('#ff79c6');
//# sourceMappingURL=constants.js.map